import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";

const { DateTime } = require("luxon");

class PartnerizeMerchantData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            merchants: [],
            merchantsLoading: false,
            MerchantsTable: {
                title: "Affiliate merchants",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'merchantName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
        this.getMerchants();
    };

    getMerchants = async () => {
        let url = `/api/Merchant/GetPartnerizeMerchants`;

        this.setState({ merchantsLoading: true });

        try {
            const merchants = await getRequest(url);

            this.setState({
                merchants,
                merchantsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching merchants:", error);
            this.setState({ merchants: [], merchantsLoading: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        const columns = [
            {
                name: "hostname",
                label: "Hostname",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value}</span>;
                    }
                }
            },
            {
                name: "campaignId",
                label: "Campaign ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "advertiserId",
                label: "Advertiser ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "title",
                label: "Title",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "destinationUrl",
                label: "Destination URL",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <a
                                href={value}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {value}
                            </a>
                        );
                    }
                }
            },
            {
                name: "description",
                label: "Description",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "campaignLogo",
                label: "Campaign Logo",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <img
                                src={value}
                                alt="Campaign Logo"
                                style={{ maxWidth: "100px", maxHeight: "50px" }}
                            />
                        );
                    }
                }
            },
            {
                name: "verticalId",
                label: "Vertical ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "campaignLanguages",
                label: "Campaign Languages",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "status",
                label: "Status",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <p style={{ textAlign: "center", margin: 0 }}>
                                {value === "a" ? "🟢 Active" : value === "r" ? "⚫ Retired" : "-"}
                            </p>
                        );
                    }
                }
            },
            {
                name: "reportingTimezone",
                label: "Reporting Timezone",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "conversionType",
                label: "Conversion Type",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "multipleConversionsPerClick",
                label: "Multiple Conversions Per Click",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <p style={{ textAlign: "center", margin: 0 }}>
                                {value === "y" ? "✅ Yes" : value === "n" ? "❌ No" : "-"}
                            </p>
                        );
                    }
                }
            },
            {
                name: "cookieStatus",
                label: "Cookie Status",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "tqEnabled",
                label: "TQ Enabled",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <p style={{ textAlign: "center", margin: 0 }}>
                                {value === "y" ? "✅ Yes" : value === "n" ? "❌ No" : "-"}
                            </p>
                        );
                    }
                }
            },
            {
                name: "isCpc",
                label: "Is CPC",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <p style={{ textAlign: "center", margin: 0 }}>
                                {value === "y" ? "✅ Yes" : value === "n" ? "❌ No" : "-"}
                            </p>
                        );
                    }
                }
            },
            {
                name: "defaultMobileDestination",
                label: "Default Mobile Destination",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "associatedCampaigns",
                label: "Associated Campaigns",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <div
                                style={{
                                    whiteSpace: "pre-wrap",
                                    maxWidth: "400px",
                                    minWidth: "300px",
                                    wordWrap: "break-word"
                                }}
                                title={value} // Full text on hover
                            >
                                {value}
                            </div>
                        )
                    }
                }
            },
            {
                name: "defaultCurrency",
                label: "Default Currency",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "restrictedDeepLinking",
                label: "Restricted Deep Linking",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "extraRestrictedDeepLinkingDomains",
                label: "Extra Restricted Deep Linking Domains",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "testMode",
                label: "Test Mode",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <p style={{ textAlign: "center", margin: 0 }}>
                                {value === "y" ? "✅ Yes" : value === "n" ? "❌ No" : "-"}
                            </p>
                        );
                    }
                }
            },
            {
                name: "allowDeepLinking",
                label: "Allow Deep Linking",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <p style={{ textAlign: "center", margin: 0 }}>
                                {value === "y" ? "✅ Yes" : value === "n" ? "❌ No" : "-"}
                            </p>
                        );
                    }
                }
            },
            {
                name: "allowThirdPartyPixel",
                label: "Allow Third Party Pixel",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <p style={{ textAlign: "center", margin: 0 }}>
                                {value === "y" ? "✅ Yes" : value === "n" ? "❌ No" : "-"}
                            </p>
                        );
                    }
                }
            },
            {
                name: "leadConfirmationUrlSuccess",
                label: "Lead Confirmation URL Success",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "leadConfirmationUrlFail",
                label: "Lead Confirmation URL Fail",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "cookiePeriod",
                label: "Cookie Period",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "verticalName",
                label: "Vertical Name",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "defaultCommissionRate",
                label: "Default Commission Rate",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <div>
                            {value}%
                        </div>
                    )
                }
            },
            {
                name: "defaultCommissionValue",
                label: "Default Commission Value",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "terms",
                label: "Terms",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <div
                                style={{
                                    maxWidth: "500px",
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    WebkitLineClamp: 5, // Limits to 5 lines
                                    overflow: "hidden"
                                }}
                            >
                                {value || "-"}
                            </div>
                        );
                    }
                }
            },
            {
                name: "termsId",
                label: "Terms ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "campaignCustomTermsAndConditionsId",
                label: "Campaign Custom Terms ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "campaignCustomTermsAndConditions",
                label: "Campaign Custom Terms",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <div
                                style={{
                                    maxWidth: "500px",
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    WebkitLineClamp: 5, // Limits to 5 lines
                                    overflow: "hidden"
                                }}
                            >
                                {value || "-"}
                            </div>
                        );
                    }
                }
            },
            {
                name: "publisherStatus",
                label: "Publisher Status",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <p style={{ textAlign: "center", margin: 0 }}>
                                {value === "a" ? "🟢 Active" : "🔴 Inactive"}
                            </p>
                        );
                    }
                }
            },
            {
                name: "performanceValue",
                label: "Performance Value",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "performanceModel",
                label: "Performance Model",
                options: {
                    filter: true,
                    sort: true
                }
            }

        ];


        return (
            <div>
                <ThemeProvider theme={this.state.MerchantsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " merchants" ?? "No affiliate selected"}</p>
                            </div>
                        }
                        data={this.state.merchants}
                        columns={columns}
                        options={{
                            ...this.state.MerchantsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.merchantsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default PartnerizeMerchantData;
